import { useState } from 'react'
import { PerfilViewFields } from '../api/schemas'
import { EntityWithIdAndDescriptionFields } from 'src/types'
import { Perfil } from '../types'
import EditIcon from '@mui/icons-material/Edit'
import toast from 'react-hot-toast'
import { HttpPerfilesABM } from '../api/httpPerfilesABM'
import { Tooltip, IconButton, Dialog, CardHeader, Card } from '@mui/material'
import { useConfirmationDialog } from 'src/hooks/useConfirmationDialog'
import { DialogPerfilABM } from './DialogPerfilABM'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'
import CachedIcon from '@mui/icons-material/Cached'

import { ItecDataGrid, ItecGridColsDef as GridColsDef, useItecDataGrid } from 'src/lib/itaptec/datagrid/src'
import { GridActionsCellItem } from '@mui/x-data-grid'
import { WrapperTable } from '../../components'

// const schemaFiltroPerfiles = z.object({
//     [PerfilRequestFields.SoloActivos]: z.boolean(),
//     [PerfilRequestFields.DescripcionPerfil]: z.string().optional()
// })

// type SchemaFiltroPerfilType = z.infer<typeof schemaFiltroPerfiles>

export const TablaPerfilesABM = () => {
    const [dialogNewOpen, setDialogNewOpen] = useState<boolean>(false)
    const [dialogEditOpen, setDialogEditOpen] = useState<Perfil>()

    const { askConfirmation } = useConfirmationDialog()

    const columnas: GridColsDef<Perfil>[] = [
        // { headerName: 'Id', field: EntityWithIdAndDescriptionFields.Id },
        { headerName: 'Nombre', field: EntityWithIdAndDescriptionFields.Description, flex: 3 },
        { headerName: 'Activo', field: PerfilViewFields.BitActivo, type: 'boolean' },
        {
            field: 'actions',
            type: 'actions',
            getActions: ({ row }) => getActions(row, true)
        }
    ]

    const getActions = (perfil: Perfil, small: boolean) => [
        perfil[PerfilViewFields.BitActivo] ? (
            <GridActionsCellItem
                onClick={() =>
                    askConfirmation(() => {
                        const promise = HttpPerfilesABM.inactivarPerfil(perfil.id)

                        toast
                            .promise(promise, {
                                success: 'Inactivado',
                                error: 'No se pudo inactivar',
                                loading: 'Inactivando'
                            })
                            .then(() => refetch())
                    })
                }
                icon={
                    <Tooltip title='Inactivar'>
                        <PersonRemoveIcon color='error' />
                    </Tooltip>
                }
                label='Inactivar'
                showInMenu={small}
            />
        ) : (
            <GridActionsCellItem
                onClick={() =>
                    askConfirmation(() => {
                        const promise = HttpPerfilesABM.activarPerfil(perfil.id)

                        toast
                            .promise(promise, {
                                success: 'Activado',
                                error: 'No se pudo activar',
                                loading: 'Activando'
                            })
                            .then(() => refetch())
                    })
                }
                icon={
                    <Tooltip title='Activar'>
                        <PersonAddIcon color='success' />
                    </Tooltip>
                }
                label='Activar'
                showInMenu={small}
            />
        ),
        <GridActionsCellItem
            key={1}
            onClick={() => {
                const promise = HttpPerfilesABM.getPerfil(perfil.id)

                toast
                    .promise(promise, {
                        success: 'Cargado.',
                        loading: 'Cargando.',
                        error: 'Error.'
                    })
                    .then(res => {
                        setDialogEditOpen(res)
                    })
            }}
            icon={
                <Tooltip title='Editar'>
                    <EditIcon color='info' />
                </Tooltip>
            }
            label='Editar'
            showInMenu={small}
        />
    ]

    const {
        datagridProps,
        control: {
            query: { refetch }
        }
    } = useItecDataGrid({
        pagination: true,
        columns: columnas,
        getEntitiesPaginated: pagination => HttpPerfilesABM.getPerfiles(pagination, { soloActivos: false }),
        density: 'compact'
    })

    return (
        <WrapperTable>
            <Card>
                <CardHeader
                    title='Administración de perfiles'
                    action={
                        <IconButton disabled={datagridProps.loading} onClick={() => refetch()}>
                            <CachedIcon />
                        </IconButton>
                    }
                />
                <ItecDataGrid {...datagridProps} />
            </Card>
            <>
                <Dialog open={dialogNewOpen} fullWidth maxWidth='sm'>
                    {dialogNewOpen && (
                        <DialogPerfilABM
                            closeDialog={() => {
                                setDialogNewOpen(false)
                                refetch()
                            }}
                        />
                    )}
                </Dialog>
                <Dialog open={!!dialogEditOpen} fullWidth maxWidth='sm'>
                    {!!dialogEditOpen && (
                        <DialogPerfilABM
                            closeDialog={() => {
                                setDialogEditOpen(undefined)
                                refetch()
                            }}
                            perfil={dialogEditOpen}
                        />
                    )}
                </Dialog>
            </>
        </WrapperTable>
    )
}
